import { render, staticRenderFns } from "./StakeeBlock.vue?vue&type=template&id=26db3710"
import script from "./StakeeBlock.vue?vue&type=script&lang=js"
export * from "./StakeeBlock.vue?vue&type=script&lang=js"
import style0 from "./StakeeBlock.vue?vue&type=style&index=0&id=26db3710&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports